module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-right-panel-2-94aba4c0addfc665cd3f8a0722cdad40.svg";